"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callout = void 0;
/* eslint-disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".callout_0508e60b .ms-Suggestions-itemButton{padding:0;border:none}.callout_0508e60b .ms-Suggestions{min-width:300px}" }]);
exports.callout = "callout_0508e60b";
//# sourceMappingURL=BaseFloatingPicker.scss.js.map